import { schema } from 'normalizr';
import catalog_entry_schema from './catalog_entry_schema';

export default new schema.Entity('catalogs', {
  catalog_entries: [catalog_entry_schema],
});
